import React, { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import { Outlet } from 'react-router';
import SettingsModals from 'components/modals/SettingsModals';
import { ActivityIndicator } from '@kontentino/ui';

const AuthorizationRoute = lazy(
  () => import('app/modules/settings/modules/me/modules/authorization'),
);

const UsersRoute = lazy(() => import('app/modules/settings/modules/users'));

const BillingRoute = lazy(() => import('app/modules/settings/modules/billing'));

const BillingReturnHandler = lazy(
  () =>
    import(
      'app/modules/settings/modules/billing/components/BillingReturnHandler'
    ),
);

const SecurityRoute = lazy(
  () => import('app/modules/settings/modules/me/modules/security'),
);

const PersonalRoute = lazy(
  () => import('app/modules/settings/modules/me/modules/personal'),
);

const NotificationsRoute = lazy(
  () => import('app/modules/settings/modules/notifications'),
);

const DevicesRoute = lazy(() => import('app/modules/settings/modules/devices'));

export const settingsRouter: RouteObject = {
  path: routeConfig.settings.path,
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-overflow-auto">
          <div className="tw-container tw-mx-auto tw-flex tw-max-w-[1800px] tw-justify-center tw-overflow-hidden tw-p-4">
            <ActivityIndicator />
          </div>
        </div>
      }
    >
      <div className="tw-h-full tw-overflow-hidden">
        <div className="tw-container tw-mx-auto tw-h-full tw-max-w-[1800px] tw-overflow-hidden">
          <Outlet />
        </div>
      </div>
      <SettingsModals />
    </Suspense>
  ),
  children: [
    {
      index: true,
      element: <Navigate to={routeConfig.settings.routes.authorization.path} />,
    },
    {
      path: routeConfig.settings.routes.authorization.path,
      element: <AuthorizationRoute />,
    },
    {
      path: routeConfig.settings.routes.users.path,
      element: <UsersRoute />,
    },
    {
      path: routeConfig.settings.routes.billing.path,
      element: <BillingRoute />,
    },
    {
      path: `${routeConfig.settings.routes.billing.path}/${routeConfig.settings.routes.billing.routes.return.path}`,
      element: <BillingReturnHandler />,
    },
    {
      path: routeConfig.settings.routes.security.path,
      element: <SecurityRoute />,
    },
    {
      path: routeConfig.settings.routes.personal.path,
      element: <PersonalRoute />,
    },
    {
      path: routeConfig.settings.routes.notifications.path,
      element: <NotificationsRoute />,
    },
    {
      path: routeConfig.settings.routes.devices.path,
      element: <DevicesRoute />,
    },
  ],
};
